// ReactJS
import './App.css';
import { useEffect, useState, useCallback } from 'react';
import axios from "axios";


// Material UI
import Grid from '@mui/material/Grid2';
import { Typography, Container, IconButton, Divider, Switch, Box, MenuItem, ListItemIcon, DialogContent, DialogContentText } from '@mui/material';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Paper from '@mui/material/Paper';
// Material UI Table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// Material UI Formulario
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Checkbox from '@mui/material/Checkbox';


// Components
import Menu from './componentes/Menu';
import AddPersiana from './componentes/AddPersiana';
import EditPersiana from './componentes/EditPersiana';
import AddArticulo from './componentes/AddArticulo';
import EditArticulo from './componentes/EditArticulo';

// Others NPM's
import { Toaster, toast } from 'alert';
import { useCookies } from 'react-cookie';

// Icons UI
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SaveIcon from '@mui/icons-material/Save';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import DescriptionIcon from '@mui/icons-material/Description';
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import KeyIcon from '@mui/icons-material/Key';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

// Styles UI
import { styled } from '@mui/material/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ModalPDF from './componentes/ModalPDF';
import { light } from '@mui/material/styles/createPalette';
import SetPassword from './componentes/SetPassword';
import AddSeccion from './componentes/AddSeccion';
import EditSeccion from './componentes/EditSeccion';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };


// Conf del Boton de Carga de Archivo JSON
const VisuallyHiddenInput = styled('input')({
	clip: 'rect(0 0 0 0)',
	clipPath: 'inset(50%)',
	height: 1,
	overflow: 'hidden',
	position: 'absolute',
	bottom: 0,
	left: 0,
	whiteSpace: 'nowrap',
	width: 1,
});


function App() {
	// =================================================
	// FUNCIONES QUE TIENEN QUE IR ANTES POR CULPA DEL PROCESO
	// =================================================

	// Fecha de Hoy
	const obtenerFechaHoy = () => {
		const hoy = new Date();
		const year = hoy.getFullYear();
		const month = String(hoy.getMonth() + 1).padStart(2, '0'); // Los meses comienzan en 0
		const day = String(hoy.getDate()).padStart(2, '0');

		return `${year}-${month}-${day}`; // Formato YYYY-MM-DD
	};

	// =================================================
	// VISUALY ESTILOS
	// =================================================

	// Estado para controlar el modo (dark o light)
	const [modo, setModo] = useState("dark");

	// Función para alternar entre los modos
	const toggleModo = useCallback(() => {
		setModo((prevModo) => (prevModo === 'dark' ? 'light' : 'dark'));
		setCookie("theme", cookies.theme === 'dark' ? 'light' : 'dark', { path: "/", maxAge: 99000000 })
	}, []);

	// Opciones del Tema de la App
	const theme = createTheme({
		typography: {
			fontSize: 18, // Cambia la escala base de la tipografía (16px por defecto)
		},
		palette: {
			mode: modo,
			ochre: {
				main: modo == "dark" ? '#ffcc00' : '#4E8272',
				light: modo == "dark" ? '#bb970c' : '#559681',
				dark: modo == "dark" ? '#bb970c' : '#355e51',
				contrastText: modo == "dark" ? "black" : 'white',
			},
			ea: {
				main: '#eaeaea',
				light: '#eaeaea',
				dark: '#eaeaea',
				contrastText: 'black',
			},
			blueRA: {
				main: '#2777cc',
				light: '#1c5da3',
				dark: '#1c5da3',
				contrastText: 'white',
			}
		},
	});

	// =================================================
	// ARRAY PRINCIPAL
	// =================================================

	// Arreglo Base
	const [base, setBase] = useState({
		opciones: {
			tipoFactura: "iva",
			dividida: false,
		},
		datosCliente: {
			nombre: "",
			direccion: "",
			fecha: obtenerFechaHoy() + "",
			cotizacion: "",
			vendedor: "Norma Aldana",
			contactovendedor: "8110500048"
		},
		articulos: [],
		articulosSeparado: {
			primera: [],
			segunda: []
		},
		totales: {
			subtotal1: "0",
			descuento: "0",
			iva: "16",
			total: "0",
			anticipo: 100,
			anticipoTotal: "0",
			pagoFinal: "0"
		},
		totalesDistribuidor: {
			subtotal1: "0",
			total: "0",
		}
	})

	// =================================================
	// COOKIES
	// =================================================
	const [cookies, setCookie] = useCookies(["number"]);
	const [last, setLast] = useState(0)
	const ultimonumero = async () => {
		try {
			const response = await axios.get(`${process.env.REACT_APP_API_URL}/ultimo_numero.php`);
			// console.log(response.data.ultimo_numero);

			setLast(response.data.ultimo_numero)
		} catch (error) {
			console.log(error);

		}
	};

	useEffect(() => {
		ultimonumero()

		// Numero Cotizacion
		let tempNumero = base;
		if (!cookies.number) {
			setCookie("number", "209", {
				path: "/",
				maxAge: 99000000
			})
			tempNumero.datosCliente.cotizacion = tempNumero
			setBase({ ...tempNumero })
		} else {
			tempNumero.datosCliente.cotizacion = parseInt(last) + 1
			setBase({ ...tempNumero })
		}

		// Thema DARK o LIGHT
		if (!cookies.theme) {
			setCookie("theme", "light", {
				path: "/",
				maxAge: 99000000
			})

			setModo("light")
		} else {
			setModo(cookies.theme)
		}


		// Set PassWord Crypt
		if (!cookies.zs2) {
			setCookie("zs2", "", {
				path: "/",
				maxAge: 99000000
			})
			setOpenPassModal(true)
			setPass("")
		} else {
			setPass(cookies.zs2)
		}

		// eslint-disable-next-line
	}, [cookies, last])


	// =================================================
	// MANEJO DE ARTICULOS
	// =================================================

	// Agrega el Articulo
	const handleArticle = (obj) => {
		// Actualiza el estado creando una nueva referencia de `articulos`
		setBase((prevBase) => ({
			...prevBase,
			articulos: [...prevBase.articulos, obj], // Copia el array existente y añade el nuevo artículo
		}));
	};

	// Editar el Articulo
	const handleEditArticle = (id, data) => {
		setBase((prevBase) => ({
			...prevBase,
			articulos: prevBase.articulos.map((articulo, index) =>
				index === id ? { ...articulo, ...data } : articulo // Nuevo array con cambios aplicados
			)
		}));
	};

	// Duplica el Articulo
	// const duplicate = (id, element) => {
	// 	const newElement = JSON.parse(JSON.stringify(element)); // Crear una copia profunda
	// 	newElement.descripcion = "(Copia) " + newElement.descripcion;

	// 	setBase((prevBase) => ({
	// 		...prevBase,
	// 		articulos: [...prevBase.articulos, newElement], // Nuevo array
	// 	}));
	// };

	const duplicate = (id, element) => {
		const newElement = JSON.parse(JSON.stringify(element)); // Crear una copia profunda
		newElement.descripcion = "(Copia) " + newElement.descripcion;

		setBase((prevBase) => {
			// Encontrar la posición del elemento original
			// const index = prevBase.articulos.findIndex((articulo) => articulo.id === id);

			// Crear una copia del array actual
			const updatedArticulos = [...prevBase.articulos];

			// Insertar el nuevo elemento justo después del original
			updatedArticulos.splice(id + 1, 0, newElement);

			// Retornar el nuevo estado
			return {
				...prevBase,
				articulos: updatedArticulos,
			};
		});
	};

	// Borra el articulo
	const borrarArticle = (id) => {
		setBase((prevBase) => ({
			...prevBase,
			articulos: prevBase.articulos.filter((_, index) => index !== id) // Nuevo array excluyendo el índice `id`
		}));
	};

	// =================================================
	// MANEJO DE TOTALES
	// =================================================

	// Suma todos los articulos cada vez que se añade uno nuevo
	useEffect(() => {

		// Suma de Articulos
		const sumaTotales = base.articulos?.reduce((acumulador, articulo) => {
			// const totalString = articulo.precio.total || "0";
			// const total = parseFloat(totalString.replace(/,/g, '')) || 0; // Elimina comas y convierte a número
			// return acumulador + total;
			let totalString = "0";
			if (articulo.tipo === "persiana") {
				totalString = articulo.precio?.total || "0";
			} else if (articulo.tipo === "articulo") {
				totalString = articulo.precio?.total || "0";
			}
			const total = parseFloat(totalString.replace(/,/g, '')) || 0; // Elimina comas y convierte a número
			return acumulador + total;

		}, 0) || 0;

		const sumaTotalesdis = base.articulos?.reduce((acumulador, articulo) => {
			let totalString = "0";
			if (articulo.tipo === "persiana") {
				totalString = articulo.distribuidor?.precio?.total || "0";
			} else if (articulo.tipo === "articulo") {
				totalString = articulo.precioDistribuidor?.total || "0";
			}
			const total = parseFloat(totalString.replace(/,/g, '')) || 0; // Elimina comas y convierte a número
			return acumulador + total;
		}, 0) || 0;


		let subtotal1 = roundDecimal(sumaTotales);
		let total = roundDecimal(subtotal1);

		let subtotal1dis = roundDecimal(sumaTotalesdis);
		let totaldis = roundDecimal(subtotal1dis);


		// Opciones de tipo factura IVA ISR
		if (base.opciones.tipoFactura == "normal") {

		} else if (base.opciones.tipoFactura == "iva") {
			total = parseFloat(handleIVA(subtotal1)) + subtotal1
			total = parseFloat(total)

			totaldis = subtotal1dis + parseFloat(handleIVA(subtotal1dis))
			totaldis = parseFloat(totaldis)

		} else if (base.opciones.tipoFactura == "isr") {
			total = subtotal1 + parseFloat(handleIVA(subtotal1))
			total = parseFloat(total)
			total = total - parseFloat(handleISR(subtotal1))
			total = parseFloat(total)

			totaldis = subtotal1dis + parseFloat(handleIVA(subtotal1dis))
			totaldis = parseFloat(totaldis)
			totaldis = totaldis - parseFloat(handleISR(subtotal1dis))
			totaldis = parseFloat(totaldis)

		}



		// Actualizacion
		// if (base.totales?.subtotal1 !== subtotal1.toLocaleString('en-US')) {
		setBase((prevBase) => ({
			...prevBase,
			totales: {
				...prevBase.totales,
				subtotal1: subtotal1.toLocaleString('en-US'),
				total: total.toLocaleString('en-US'),
			},
			totalesDistribuidor: {
				...prevBase.totalesDistribuidor,
				subtotal1: subtotal1dis.toLocaleString('en-US'),
				total: totaldis.toLocaleString('en-US'),
			},
		}));
		handleGuardarDB()
		// toast.success("Se actualizó correctamente");
		// }
	}, [base.articulos, base.opciones.tipoFactura]);

	// Define los totales cuando cambio los Inputs dentro de la pantalla principal
	const handleTotalsChange = (event) => {
		const { name, value } = event.target;

		setBase((prevBase) => {
			// Crear una copia segura de `totales`
			const nuevosTotales = {
				...prevBase.totales,
				[name]: value === "" ? "" : parseFloat(value.replace(/,/g, "")) || 0, // Limpiar comas y manejar valores vacíos
			};

			// Obtener valores con manejo de errores
			const subtotal1 = parseFloat(nuevosTotales.subtotal1.replace(/,/g, "")) || 0;

			// Calcular valores derivados
			const total = subtotal1

			// Retornar el nuevo estado con valores formateados
			return {
				...prevBase,
				articulosSeparado: {
					primera: calculateAdvance(total, nuevosTotales.anticipo, base.articulos).mitad1,
					segunda: calculateAdvance(total, nuevosTotales.anticipo, base.articulos).mitad2
				},
				totales: {
					...nuevosTotales,
					anticipo: nuevosTotales.anticipo,
					pagoFinal: calculateAdvance(total, nuevosTotales.anticipo, base.articulos).pago2,
					anticipoTotal: calculateAdvance(total, nuevosTotales.anticipo, base.articulos).pago1,
					total: formatNumber(total),
				},
			};
		});


	};

	// Cambio a Impuestos IVA o ISR
	const handleChangeFactura = (event) => {
		let tempBase = base
		tempBase.opciones.tipoFactura = event.target.value
		setBase({ ...tempBase })
	};

	// Cambio a Factura Dividida
	const handleSwitchChange = (event) => {
		let tempBase = base
		tempBase.opciones.dividida = event.target.checked
		if (event.target.checked) {
			tempBase.totales.anticipo = 60
			tempBase.articulosSeparado.primera = calculateAdvance(tempBase.totales.total, 60, tempBase.articulos).mitad1
			tempBase.articulosSeparado.segunda = calculateAdvance(tempBase.totales.total, 60, tempBase.articulos).mitad2
			tempBase.totales.pagoFinal = calculateAdvance(tempBase.totales.total, 60, tempBase.articulos).pago2
			tempBase.totales.anticipoTotal = calculateAdvance(tempBase.totales.total, 60, tempBase.articulos).pago1
		} else {
			tempBase.totales.anticipo = 100
		}
		setBase({ ...tempBase })
	};

	// Divide los productos
	const calculateAdvance = (total, advance, articlesArray) => {
		const totalParsed = parseStringToFloat(total + " ");
		const totalPorcent = (advance / 100) * totalParsed

		let arrayPorcent = []
		let arrayRest = []

		let acumulador = 0
		const sortedArticles = [...articlesArray].sort((a, b) => parseStringToFloat(b.precio.total) - parseStringToFloat(a.precio.total));
		for (const article of sortedArticles) {
			const price = parseStringToFloat(article.precio.total);

			if ((acumulador + price) >= totalPorcent) {
			} else {
				acumulador = acumulador + price
				arrayPorcent.push(article)
			}
		}
		arrayRest = sortedArticles.filter((item) => !arrayPorcent.includes(item));

		return {
			mitad1: arrayPorcent,
			mitad2: arrayRest,
			pago1: formatNumber(acumulador),
			pago2: formatNumber(totalParsed - acumulador)

		}
	}

	// =================================================
	// FUNCIONES DE MANEJO DE FORMATOS Y OPERACIONES CONCRETAS
	// =================================================

	// Quita Formato y tranforma a Entero
	const parseStringToFloat = (str) => {
		return parseFloat(str.replace(/,/g, ''));
	};

	// Formatea el Numero a String con coma en los millares.
	const formatNumber = (num) =>
		num.toLocaleString("en-US", {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
			useGrouping: true,
		});

	// Obtiene el descuento
	const porcent = (part, total) => {
		return total - ((part * total) / 100)
	}

	// Suma de porcentaje
	const porcentplus = (part, total) => {
		return total + ((part * total) / 100)
	}

	// Verifica que exista un digito
	const checkValue = (attr) => {
		return !attr || attr === 0 ? 0 : attr
	}

	// Redondea las decimales
	const roundDecimal = (number) => {
		let total = checkValue(number)
		total = parseFloat(total)
		let redondeado = parseFloat(total.toFixed(2))
		return redondeado;
	}

	// Detecta si esta Vacio
	function tieneStringVacio(obj) {
		for (const key in obj) {
			if (obj[key] === "") {
				return true;
			}
		}
		return false;
	}

	// Calcula el ISR
	const handleISR = (element) => {
		return (parseFloat(esString(element) ? element.replace(/[^0-9.-]+/g, "") : element) * 0.015).toFixed(2)
	}

	// Calcula el IVA
	const handleIVA = (element) => {
		return (parseFloat(esString(element) ? element.replace(/[^0-9.-]+/g, "") : element) * 0.16).toFixed(2)
	}

	function esString(variable) {
		return Object.prototype.toString.call(variable) === "[object String]";
	}

	// =================================================
	// MANEJO DE ARCHIVO JSON
	// =================================================

	// Cambio de informacion del Cliente
	const handleChangeData = (e) => {
		let tempBase = base
		switch (e.target.id) {
			case "cotizacion":
				tempBase.datosCliente.cotizacion = e.target.value
				break;
			case "nombre":
				tempBase.datosCliente.nombre = e.target.value
				break;
			case "fecha":
				tempBase.datosCliente.fecha = e.target.value
				break;
			case "direccion":
				tempBase.datosCliente.direccion = e.target.value
				break;
			case "vendedor":
				tempBase.datosCliente.vendedor = e.target.value
				break;
			case "contactovendedor":
				tempBase.datosCliente.contactovendedor = e.target.value
				break;

			default:
				break;
		}
		setBase({ ...tempBase })
	}

	// Cargar Archivo JSON
	const handleFileUpload = (event) => {
		const file = event.target.files[0]

		if (!file) {
			toast.error('Cuidado, no cargo el archivo.');
			return false
		};

		const reader = new FileReader();

		reader.onload = (e) => {
			const json = JSON.parse(e.target.result);
			let decrypt = decryptArray(json, pass)
			if (decrypt == null) {
				toast.error("No es la clave, la pagina se va recargar.")
				setTimeout(() => {
					window.location.reload();
				}, 2000);
				return false
			}


			decrypt.articulos.forEach(element => {
				if (!element.distribuidor) {
					element.distribuidor = {
						precio: {
							compartido: "",
							subtotal: "",
							total: "",
						},
						descuento: {
							primero: 0,
							compartido: 0,
						},
					};
				}
			});

			if (!decrypt.totalesDistribuidor) {
				decrypt.totalesDistribuidor = {
					subtotal1: "0",
					total: "0",
				}
			}

			setBase({ ...decrypt });
		};

		reader.readAsText(file);
	};

	// console.log(base);


	// Guardar Archivo JSON 
	const handleSaveJson = async () => {
		let tempjson = encryptArray(base, pass);

		if (tieneStringVacio(tempjson.datosCliente)) {
			toast.error('Te faltan datos.');
			return false;
		}

		const data = JSON.stringify(tempjson, null, 2);
		const suggestedName = `${base.datosCliente.cotizacion}_${base.datosCliente.nombre}.json`;

		try {
			const options = {
				suggestedName: suggestedName,
				types: [{
					description: 'JSON Files',
					accept: { 'application/json': ['.json'] }
				}]
			};
			const handle = await window.showSaveFilePicker(options);

			// Escribir el archivo
			const writable = await handle.createWritable();
			await writable.write(data);
			await writable.close();

			toast.success('Archivo guardado exitosamente.');
			if (cookies.number == base.datosCliente.cotizacion) {
				setCookie("number", (cookies.number + 1), { path: "/", maxAge: 99000000 })
			}
		} catch (err) {
			if (err.name !== 'AbortError') {
				toast.error('Hubo un problema al guardar el archivo.');
			} else {
				toast.success('Cancelaste las operacion.');
				console.log('El usuario canceló la operación.');
			}
		}
	};

	// =================================================
	// Encryptacion del archivo array
	// =================================================

	const [pass, setPass] = useState("")
	const [openPassModal, setOpenPassModal] = useState(false)
	const handlePassModal = () => {
		setOpenPassModal((prevModo) => (prevModo ? false : true));
	}

	useEffect(() => {
		setCookie("zs2", pass, {
			path: "/",
			maxAge: 99000000
		})
	}, [pass])

	const CryptoJS = require('crypto-js');

	// Función para cifrar el array
	function encryptArray(array, key) {
		// Convertir el array en una cadena JSON
		const dataString = JSON.stringify(array);

		// Cifrar con AES
		const encrypted = CryptoJS.AES.encrypt(dataString, key).toString();
		return encrypted;
	}

	// Función para descifrar el array
	function decryptArray(encryptedString, key) {
		try {
			// Descifrar la cadena
			const bytes = CryptoJS.AES.decrypt(encryptedString, key);
			const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

			// Convertir de nuevo a un array
			return JSON.parse(decryptedString);
		} catch (e) {
			console.error("Error al descifrar. ¿La clave es incorrecta?", e);
			return null;
		}
	}

	const sumametroscuadrados = () => {
		let suma = 0
		base.articulos.forEach((element, id) => {
			if (element.tipo === "persiana") {
				suma = suma + (element.medida.m2 * element.cantidad)
			}
		})
		return suma
	}

	// Funciones Plus

	document.addEventListener('keydown', (event) => {
		if (event.ctrlKey && event.key === 's') {
			event.preventDefault();
			handleSaveJson();
		}
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Enter' && event.target.tagName === 'INPUT') {
			event.preventDefault(); // Prevenir el comportamiento predeterminado
		}
	});

	// =================================================
	// RANDOM QUE VAN APARECIENDO ASI BIEN LOCOCHON
	// =================================================

	// useEffect(() => {
	// 	handleGuardarDB()
	// }, [base])

	const handleGuardarDB = () => {
		guardarCotizacion()
	}

	const guardarCotizacion = async () => {
		let tempjson = encryptArray(base, pass);
		if (base.datosCliente.nombre == "" || base.datosCliente.cotizacion == "") {
			return false;
		}
		try {
			const data = {
				nombre: base.datosCliente.nombre,
				numero_cotizacion: base.datosCliente.cotizacion,
				cotizacion: tempjson
			};

			const response = await axios.post(`${process.env.REACT_APP_API_URL}/guardar.php`, data, {
				headers: {
					"Content-Type": "application/json"
				}
			});

			console.log(response.data); // Mensaje del backend
			toast.success("Archivo Guardado Correctamente");
		} catch (error) {
			toast.error("Error Al guardar")
			console.error("Error al guardar cotización:", error.response ? error.response.data : error.message);
		}
	};

	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
		obtenerListaCotizaciones()
	};

	const handleClose = () => {
		setOpen(false);
	};

	const [cotizaciones, setCotizaciones] = useState([]);
	const [error, setError] = useState(null);

	const obtenerListaCotizaciones = async () => {
		try {
			const response = await axios.get(`${process.env.REACT_APP_API_URL}/ver_lista.php`);
			setCotizaciones(response.data); // Guardar la lista en el estado
		} catch (error) {
			console.error("Error al obtener la lista:", error.response ? error.response.data : error.message);
			setError(error);
		}
	};

	const duplicarCotizacionPorId = async (id) => {
		try {
			const response = await axios.get(`${process.env.REACT_APP_API_URL}/duplicarCotizacion.php?id=${id}`);
			console.log(response.data); // Ver la cotización en consola
			toast.success("Archivo Guardado Correctamente");
			obtenerListaCotizaciones()
		}
		catch (error) {
			console.error("Error al duplicar la cotización:", error.response ? error.response.data : error.message);
			return null;
		}
	}
	const obtenerCotizacionPorId = async (id) => {
		try {
			const response = await axios.get(`${process.env.REACT_APP_API_URL}/obtener.php?id=${id}`);
			console.log(response.data); // Ver la cotización en consola

			let decrypt = decryptArray(response.data.cotizacion, pass)
			if (decrypt == null) {
				toast.error("No es la clave, la pagina se va recargar.")
				setTimeout(() => {
					window.location.reload();
				}, 2000);
				return false
			}


			decrypt.articulos.forEach(element => {
				if (!element.distribuidor) {
					element.distribuidor = {
						precio: {
							compartido: "",
							subtotal: "",
							total: "",
						},
						descuento: {
							primero: 0,
							compartido: 0,
						},
					};
				}
			});

			if (!decrypt.totalesDistribuidor) {
				decrypt.totalesDistribuidor = {
					subtotal1: "0",
					total: "0",
				}
			}

			setBase({ ...decrypt });
			handleClose()
			return response.data;
		} catch (error) {
			console.error("Error al obtener la cotización:", error.response ? error.response.data : error.message);
			return null;
		}
	};

	const moverArticulo = (index, direccion) => {
		setBase((prev) => {
			const nuevo = [...prev.articulos];
			const newIndex = index + direccion;

			// Validar límites
			if (newIndex < 0 || newIndex >= nuevo.length) return prev;

			// Intercambiar
			const temp = nuevo[index];
			nuevo[index] = nuevo[newIndex];
			nuevo[newIndex] = temp;

			return {
				...prev,
				articulos: nuevo, // actualizamos SOLO los artículos
			};
		});
	};

	const [viewType, setViewType] = useState({ cliente: true, distribuidor: false })

	const handleView = (e) => {
		let x = viewType
		switch (e.target.id) {
			case "clienteview":
				x.cliente = true
				x.distribuidor = false
				setViewType({ ...x })
				break;
			case "distribuidorview":
				x.cliente = false
				x.distribuidor = true
				setViewType({ ...x })
				break;

			default:
				break;
		}

	}

	return (
		<div className="App">
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<Toaster position='bottom-left' />


				<Dialog onClose={handleClose} open={open} maxWidth={"md"} fullWidth>
					<DialogTitle>Cotizaciones</DialogTitle>

					<DialogContent>
						{cotizaciones.length !== 0 &&
							cotizaciones.map((element, id) => {
								return (
									<div className='' key={id}>
										<Grid container spacing={5}>
											<Grid size={8}>
												<Typography color='blueRA' className="mr-4 font-bold" component="h5">
													{element.numero_cotizacion} -
													{element.nombre}
												</Typography>
												<Typography color='ochre' className="ml-4" component="subtitle1">Creado el <b>{element.fecha}</b></Typography>
											</Grid>
											<Grid size={4} style={{ display: "flex", justifyContent: "flex-end" }}>
												<Button variant='outlined' color='success' size='small' onClick={() => { obtenerCotizacionPorId(element.id) }}><ThumbUpAltIcon /></Button>
												<Button variant='outlined' size='small' className='mx-5' onClick={() => { duplicarCotizacionPorId(element.id) }}><ContentCopyIcon /></Button>
											</Grid>
										</Grid>
										<Divider className='mt-3' />
										<br />
									</div>
								)
							}
							)}
						{/* Aqui 1 */}
					</DialogContent>

				</Dialog>
				<Menu
					handleClickOpen={handleClickOpen}
					guardarDB={handleGuardarDB}
					base={base}
					subirArchivo={handleFileUpload}
					// guardarArchivo={handleSaveJson}
					agregarPersiana={
						<AddPersiana
							handleArticle={handleArticle}
							textbtn='Persiana'
							icon={<LibraryAddIcon />}
							tieneStringVacio={tieneStringVacio}
							toast={toast}
						/>
					}
					agregarArticulo={
						<AddArticulo
							tieneStringVacio={tieneStringVacio}
							handleArticle={handleArticle}
							toast={toast}
						/>
					}
					toggleModo={toggleModo}
					modalPDF={
						<ModalPDF base={base}>

						</ModalPDF>
					}

					setPassword={
						<SetPassword handleOpen={handlePassModal} open={openPassModal} setPass={setPass} pass={pass}>
							<MenuItem>
								<ListItemIcon>
									<KeyIcon />
								</ListItemIcon>
								{/* {pass} */}

							</MenuItem>
						</SetPassword>
					}
				/>

				<Container style={{ marginBottom: "80px" }} maxWidth="xl">

					<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 4, sm: 10, md: 12 }} className="justify-center mt-3 mb-5">

						{/* Datos Generales Cotizacion */}
						<Grid size={{ xs: 4, sm: 10, md: 12 }}>
							{/* Datos del Cliente */}
							<Card className='my-5 cardpkm'>
								<CardContent>
									<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 4, sm: 10, md: 12 }}>
										<Grid size={{ xs: 4, sm: 10, md: 12 }}>
											<Typography color='ochre' className="ml-4 font-bold" component="h2">Datos del Cliente</Typography>
										</Grid>
										<Grid size={{ xs: 4, sm: 10, md: 12 }}>
											<hr className='mb-4' />
										</Grid>
										<Grid size={{ xs: 4, sm: 5, md: 3 }}>
											<TextField
												fullWidth
												id="cotizacion"
												label="Numero de Cotizacion"
												variant="outlined"
												type='number'
												value={base.datosCliente.cotizacion}
												onChange={handleChangeData}
											/>
										</Grid>
										<Grid size={{ xs: 4, sm: 5, md: 9 }}>
											<TextField
												fullWidth
												id="nombre"
												label="Nombre"
												variant="outlined"
												value={base.datosCliente.nombre}
												onChange={handleChangeData}
											/>
										</Grid>
										<Grid size={{ xs: 4, sm: 5, md: 3 }}>
											<TextField
												fullWidth
												id="fecha"
												label="Fecha"
												variant="outlined"
												type='date'
												value={base.datosCliente.fecha}
												onChange={handleChangeData}
											/>
										</Grid>
										<Grid size={{ xs: 4, sm: 5, md: 9 }}>
											<TextField
												fullWidth
												id="direccion"
												label="Direccion"
												variant="outlined"
												value={base.datosCliente.direccion}
												onChange={handleChangeData}
											/>
										</Grid>
										<Grid size={{ xs: 4, sm: 5, md: 6 }}>
											<TextField
												fullWidth
												id="vendedor"
												label="Nombre Vendedor"
												variant="outlined"
												value={base.datosCliente.vendedor}
												onChange={handleChangeData}
											/>
										</Grid>
										<Grid size={{ xs: 4, sm: 5, md: 6 }}>
											<TextField
												fullWidth
												id="contactovendedor"
												label="Telefono Vendedor"
												variant="outlined"
												value={base.datosCliente.contactovendedor}
												onChange={handleChangeData}
											/>
										</Grid>
										<Grid size={{ xs: 4, sm: 10, md: 12 }}>
											<hr className='mt-4' />
										</Grid>
										<Grid size={{ xs: 4, sm: 10, md: 12 }} className="flex justify-center align-center">

											<FormControl>
												<RadioGroup
													aria-labelledby="demo-radio-buttons-group-label"
													defaultValue="normal"
													name="radio-buttons-group"
													className="flex"
													style={{ flexDirection: "row" }}
													value={base.opciones.tipoFactura}
													onChange={handleChangeFactura}
												>
													<FormControlLabel value="normal" control={<Radio color='blueRA' />} label="Normal" />
													<FormControlLabel value="iva" control={<Radio color='blueRA' />} label="IVA" />
													<FormControlLabel value="isr" control={<Radio color='blueRA' />} label="IVA + ISR" />
												</RadioGroup>
											</FormControl>
										</Grid>
									</Grid>
								</CardContent>
							</Card>
						</Grid>

						{/* Articulos Lista */}
						<Grid size={{ xs: 4, sm: 10, md: 12 }}>
							<Card className='my-5 cardpkm'>
								<CardContent>
									<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 4, sm: 10, md: 12 }}>
										<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center">
											<Typography color='ochre' className="ml-4 font-bold" component="h2">Conceptos</Typography>
										</Grid>

										<Grid size={{ xs: 4, sm: 10, md: 12 }}>
											<hr className='mb-4' />
										</Grid>

										<Grid size={{ xs: 4, sm: 10, md: 12 }}>
											<TableContainer className='barscroll cardpkmtable'>
												<Table sx={{ minWidth: 1050 }} stickyHeader aria-label="table">
													<TableHead>
														<TableRow>
															<TableCell>Mover</TableCell>
															<TableCell>Descripcion General</TableCell>
															<TableCell align="center">Cantidad</TableCell>
															<TableCell align="left">Precios</TableCell>
															<TableCell align="left">Descuentos</TableCell>
															<TableCell align="center">Total</TableCell>
															{(base.opciones.tipoFactura == "iva" || base.opciones.tipoFactura == "isr") && <TableCell align="left">Impuestos</TableCell>}
															<TableCell align="center">Opciones</TableCell>
														</TableRow>
													</TableHead>
													<TableBody>
														{base.articulos.length !== 0 &&
															base.articulos.map((element, id) => {
																if (element.tipo === "persiana") {
																	return (
																		<TableRow
																			key={id}
																			sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
																		>

																			<TableCell component="th" scope="row">
																				<div style={{ display: "flex" }}>
																					<IconButton aria-label="up" size="large">
																						<ArrowCircleUpIcon onClick={() => moverArticulo(id, -1)} />
																					</IconButton>
																					<IconButton aria-label="down" size="large">
																						<ArrowCircleDownIcon onClick={() => moverArticulo(id, 1)} />
																					</IconButton>
																				</div>
																			</TableCell>
																			<TableCell component="th" scope="row">
																				<Typography className='text-1xl text-bold borderbottomwhite' color='blueRA'>{element.descripcion} </Typography>
																				<div>
																					<span className='mr-4'>Ancho <b>{element.medida.ancho}m</b></span>
																					<span className='mr-4'>Alto: <b>{element.medida.alto}m</b> </span>
																					<span><b>{parseFloat(element.medida.m2).toFixed(2)}m<sup>2</sup> </b></span>
																				</div>
																				<div>
																					<span className='mr-4'>Area: <b>{element.area}</b></span>
																					<span>Control: <b>{element.direccion}</b></span>
																				</div>
																			</TableCell>
																			<TableCell align="center"><Typography variant='h6' color='ochre'><b>{element.cantidad}</b></Typography></TableCell>
																			<TableCell align="left">
																				<div className='flex justify-between'><span>Metro<sup>2 </sup> :</span> ${element.precio.m2}</div>
																				<Typography variant='subtitle2' color='ochre' className='flex justify-between'><span>Unitario:</span> ${element.precio.unitario}</Typography>

																				{/* Vista de Cliente/Distribuidor */}
																				{viewType.cliente &&
																					<Typography variant='subtitle2' className='flex justify-between'><span>SubTotal:</span> ${element.precio.subtotal}</Typography>
																				}
																				{viewType.distribuidor &&
																					<Typography variant='subtitle2' className='flex justify-between'><span>SubTotal:</span> ${element.distribuidor.precio.subtotal}</Typography>
																				}

																			</TableCell>

																			{/* Vista de Cliente/Distribuidor */}
																			{viewType.cliente &&
																				<TableCell align="left">
																					<div className='flex justify-between'> {"\u00A0"}</div>
																					<Typography variant='subtitle2' color='ochre' className='flex justify-between'><span>Gral: </span> {element.descuento.primero}%</Typography>
																					<div className='flex justify-between'><span>Adi: </span> {element.descuento.compartido}%</div>
																				</TableCell>
																			}
																			{viewType.distribuidor &&
																				<TableCell align="left">
																					<div className='flex justify-between'> {"\u00A0"}</div>
																					<Typography variant='subtitle2' color='ochre' className='flex justify-between'><span>Gral: </span> {element.distribuidor.descuento.primero}%</Typography>
																					<div className='flex justify-between'><span>Adi: </span> {element.distribuidor.descuento.compartido}%</div>
																				</TableCell>
																			}

																			{/* Vista de Cliente/Distribuidor */}
																			{viewType.cliente &&
																				<TableCell align="center"><b>${element.precio.total}</b></TableCell>
																			}
																			{viewType.distribuidor &&
																				<TableCell align="center"><b>${element.distribuidor.precio.total}</b></TableCell>
																			}

																			{/* Ver IVA o ISR */}
																			{(base.opciones.tipoFactura == "iva" || base.opciones.tipoFactura == "isr") &&
																				<TableCell align="left">
																					<div className='flex justify-between'> {"\u00A0"}</div>
																					{viewType.cliente &&
																						<Typography variant='subtitle2' color='light' className='flex justify-between'><span>IVA:</span> ${handleIVA(element.precio.total)}</Typography>
																					}
																					{viewType.distribuidor &&
																						<Typography variant='subtitle2' color='light' className='flex justify-between'><span>IVA:</span> ${handleIVA(element.distribuidor.precio.total)}</Typography>
																					}


																					{base.opciones.tipoFactura == "isr" &&
																						<Typography variant='subtitle2' color='ochre' className='flex justify-between'>
																							{viewType.cliente &&
																								<span>ISR: ${handleISR(element.precio.total)}</span>
																							}
																							{viewType.distribuidor &&
																								<span>ISR: ${handleISR(element.distribuidor.precio.total)}</span>
																							}
																						</Typography>
																					}
																					<div className='flex justify-between'> {"\u00A0"}</div>
																				</TableCell>
																			}
																			<TableCell align="center">
																				<div className='flex justify-evenly'>
																					<EditPersiana
																						edit={element}
																						handleEditArticle={handleEditArticle}
																						articleId={id}
																						tieneStringVacio={tieneStringVacio}
																						toast={toast}
																					></EditPersiana>
																					<IconButton color='ochre' aria-label="delete" onClick={() => { duplicate(id, element) }}>
																						<ContentCopyIcon />
																					</IconButton>
																					<IconButton onClick={() => { borrarArticle(id) }} color="" aria-label="add to shopping cart">
																						<DeleteIcon />
																					</IconButton>
																				</div>
																			</TableCell>
																		</TableRow>
																	)
																} else if (element.tipo === "articulo") {
																	return (
																		<TableRow
																			key={id}
																			sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
																		>
																			<TableCell component="th" scope="row">
																				<div style={{ display: "flex" }}>
																					<IconButton aria-label="up" size="large">
																						<ArrowCircleUpIcon onClick={() => moverArticulo(id, -1)} />
																					</IconButton>
																					<IconButton aria-label="down" size="large">
																						<ArrowCircleDownIcon onClick={() => moverArticulo(id, 1)} />
																					</IconButton>
																				</div>
																			</TableCell>
																			<TableCell component="th" scope="row">
																				<Typography className='text-1xl text-bold borderbottomwhite' color='blueRA'>{element.nombre} </Typography>
																				{element.datos.descripcion !== "" &&
																					<div>
																						<span className='mr-4'>{element.datos.descripcion}</span>
																					</div>
																				}
																				{element.datos.datosextra !== "" &&
																					<div>
																						<span className='mr-4'>{element.datos.datosextra}</span>
																					</div>
																				}
																			</TableCell>
																			<TableCell component="th" scope="row" align="center">
																				{element.cantidad}
																			</TableCell>
																			<TableCell component="th" scope="row" >
																				<Typography variant='subtitle2' color='ochre' className='flex justify-between'><span>Unitario:</span> ${element.precio.precioUnitario}</Typography>
																				<Typography variant='subtitle2' className='flex justify-between'><span>SubTotal:</span> ${element.precio.subtotal}</Typography>
																			</TableCell>
																			{/* Vista de Cliente/Distribuidor */}
																			{viewType.cliente &&
																				<TableCell component="th" scope="row" >
																					{/* <div className='flex justify-between'> {"\u00A0"}</div> */}
																					<div className='flex justify-between'><span>Gral.:</span> {element.precio.descuento}%</div>
																					<div className='flex justify-between'><span>Ad.:</span> {element.precio.descuentoAd}%</div>
																				</TableCell>
																			}
																			{viewType.distribuidor &&
																				<TableCell component="th" scope="row" >
																					{/* <div className='flex justify-between'> {"\u00A0"}</div> */}
																					<div className='flex justify-between'><span>Gral.:</span> {element.precioDistribuidor.descuento}%</div>
																					<div className='flex justify-between'><span>Ad.:</span> {element.precioDistribuidor.descuentoAd}%</div>
																				</TableCell>
																			}
																			{/* Vista de Cliente/Distribuidor */}
																			{viewType.cliente &&
																				<TableCell component="th" scope="row" align="center">
																					{/* <div className='flex justify-between'> {"\u00A0"}</div> */}
																					<Typography className='text-1xl text-bold'><b>${element.precio.subtotal1}</b> </Typography>
																					<Typography className='text-1xl text-bold'><b>${element.precio.total}</b> </Typography>
																				</TableCell>
																			}
																			{viewType.distribuidor &&
																				<TableCell component="th" scope="row" align="center">
																					{/* <div className='flex justify-between'> {"\u00A0"}</div> */}
																					<Typography className='text-1xl text-bold'><b>${element.precioDistribuidor.subtotal1}</b> </Typography>
																					<Typography className='text-1xl text-bold'><b>${element.precioDistribuidor.total}</b> </Typography>
																				</TableCell>
																			}
																			{(base.opciones.tipoFactura == "iva" || base.opciones.tipoFactura == "isr") &&
																				<TableCell align="left">
																					{/* Vista de Cliente/Distribuidor */}
																					{viewType.cliente &&
																						<Typography variant='subtitle2' color='light	' className='flex justify-between'><span>IVA:</span> ${handleIVA(element.precio.total)}</Typography>
																					}
																					{viewType.distribuidor &&
																						<Typography variant='subtitle2' color='light	' className='flex justify-between'><span>IVA:</span> ${handleIVA(element.precioDistribuidor.total)}</Typography>
																					}
																					{base.opciones.tipoFactura == "isr" &&
																						<Typography variant='subtitle2' color='ochre' className='flex justify-between'>
																							{/* Vista de Cliente/Distribuidor */}
																							{viewType.cliente &&
																								<span>ISR: ${handleISR(element.precio.total)}</span>
																							}
																							{viewType.distribuidor &&
																								<span>ISR: ${handleISR(element.precioDistribuidor.total)}</span>
																							}
																						</Typography>
																					}
																				</TableCell>
																			}
																			<TableCell align="center">
																				<div className='flex justify-evenly'>
																					<EditArticulo
																						edit={element}
																						handleEditArticle={handleEditArticle}
																						articleId={id}
																						tieneStringVacio={tieneStringVacio}
																						toast={toast}
																					></EditArticulo>
																					<IconButton color='ochre' aria-label="delete" onClick={() => { duplicate(id, element) }}>
																						<ContentCopyIcon />
																					</IconButton>
																					<IconButton onClick={() => { borrarArticle(id) }} color="" aria-label="add to shopping cart">
																						<DeleteIcon />
																					</IconButton>
																				</div>
																			</TableCell>
																		</TableRow>
																	)
																} else if (element.tipo === "seccion") {
																	return (
																		<TableRow
																			key={id}
																			sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
																			className='separador'
																		>
																			<TableCell component="th" scope="row">
																				<div style={{ display: "flex" }}>
																					<IconButton aria-label="up" size="large">
																						<ArrowCircleUpIcon onClick={() => moverArticulo(id, -1)} />
																					</IconButton>
																					<IconButton aria-label="down" size="large">
																						<ArrowCircleDownIcon onClick={() => moverArticulo(id, 1)} />
																					</IconButton>
																				</div>
																			</TableCell>
																			<TableCell component="th" scope="row" style={{ width: "100%" }} colSpan={6}>
																				<Typography className='text-1xl text-bold borderbottomwhite text-center' color='blueRA'>{element.nombre} </Typography>
																				<Typography className='text-1xl borderbottomwhite text-center' color='ochre'>{element.piso} </Typography>
																				{/* {element.nombre !== "" &&
																					<div>
																						<span className='mr-4'>{element.piso}</span>
																					</div>
																				}																				 */}
																			</TableCell>
																			<TableCell align="center">
																				<div className='flex justify-evenly'>

																					<EditSeccion
																						edit={element}
																						handleEditArticle={handleEditArticle}
																						articleId={id}
																						tieneStringVacio={tieneStringVacio}
																						toast={toast}
																					></EditSeccion>
																					<IconButton color='ochre' aria-label="delete" onClick={() => { duplicate(id, element) }}>
																						<ContentCopyIcon />
																					</IconButton>
																					<IconButton onClick={() => { borrarArticle(id) }} color="" aria-label="add to shopping cart">
																						<DeleteIcon />
																					</IconButton>
																				</div>
																			</TableCell>
																		</TableRow>
																	)
																}
															})
														}
													</TableBody>
												</Table>
											</TableContainer>
										</Grid>

										{/* {base.articulos.length > 3 &&
											<Grid size={{ xs: 4, sm: 10, md: 12 }}>
												<hr />
											</Grid>
										}
										{base.articulos.length > 3 &&
											<Grid size={{ xs: 4, sm: 5, md: 12 }} className="flex justify-end">
												<AddPersiana
													handleArticle={handleArticle}
													textbtn='Persiana'
													icon={<LibraryAddIcon />}
													tieneStringVacio={tieneStringVacio}
													toast={toast}
												/>

												<AddArticulo
													tieneStringVacio={tieneStringVacio}
													handleArticle={handleArticle}
													toast={toast}
												/>
											</Grid>
										} */}
									</Grid>
								</CardContent>
							</Card>

						</Grid>

						{/* Lodel ISR ************DESCONTINUADO************ */}
						<div>
							{/* <Grid size={{ xs: 4, sm: 10, md: 12 }}>
							<Card className='my-5 cardpkm'>
								<CardContent>
									<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 4, sm: 10, md: 12 }} className="align-center">
										<Grid size={{ xs: 4, sm: 10, md: 5 }} className="flex justify-center align-center">

											<FormControl>
												<RadioGroup
													aria-labelledby="demo-radio-buttons-group-label"
													defaultValue="normal"
													name="radio-buttons-group"
													className="flex"
													style={{ flexDirection: "row" }}
													value={base.opciones.tipoFactura}
													onChange={handleChangeFactura}
												>
													<FormControlLabel value="normal" control={<Radio color='blueRA' />} label="Normal" />
													<FormControlLabel value="iva" control={<Radio color='blueRA' />} label="IVA" />
													<FormControlLabel value="isr" control={<Radio color='blueRA' />} label="IVA + ISR" />
												</RadioGroup>
											</FormControl>
										</Grid>
										<Grid size={{ xs: 4, sm: 5, md: 5 }} className="flex justify-center align-center">
											<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 12 }}>
												<Grid size={{ xs: 6 }} className="flex items-center">


													<FormGroup className="ml-4">
														<FormControlLabel
															control={
																<Switch
																	color="ochre"
																	checked={base.opciones.dividida} // Vincula el estado al componente
																	onChange={handleSwitchChange} // Detecta los cambios
																/>
															}
															label="Dividida"
														/>
													</FormGroup>
												</Grid>
												<Grid size={{ xs: 6 }} className="flex items-center">
													<TextField
														id="anticipo"
														name="anticipo"
														label="Anticipo %"
														variant={!base.opciones.dividida ? "standard" : "outlined"}
														type='number'
														color={"ochre"}
														size="small"
														disabled={!base.opciones.dividida}
														inputProps={{ min: 0 }}
														value={base.totales.anticipo || ""}
														onChange={handleTotalsChange}
													></TextField>
												</Grid>
											</Grid>
										</Grid>
										<Grid size={{ xs: 4, sm: 5, md: 2 }} className="flex justify-center align-center">

										</Grid>
									</Grid>
								</CardContent>
							</Card>
						</Grid> */}
						</div>

						{/* Totales */}
						<Grid size={{ xs: 4, sm: 10, md: 12 }}>
							<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 4, sm: 10, md: 12 }} className="justify-center mt-3 mb-5">
								<Grid size={{ xs: 4, sm: 10, md: 6 }}>
									<Card className='my-5 cardpkm'>
										<CardContent>
											{/* <div>
												<Checkbox
													{...label}
													defaultChecked
													sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
													id='clienteview'
													name='clienteview'
													checked={viewType.cliente}
													onChange={(e) => handleView(e)}
												/>
												<label >Ver modo Cliente</label>
											</div> */}
											<Typography className='mr-6 text-center' variant='h6' color='ochre'>Cliente</Typography>
											<div className='flex justify-between items-center px-10 my-1'>
												<Typography className='mr-6' variant='h6' color='ochre'>SubTotal</Typography>
												<Typography variant='h6'><b>${base.totales.subtotal1}</b></Typography>
											</div>
											{(base.opciones.tipoFactura == "iva" || base.opciones.tipoFactura == "isr") &&
												<div className='flex justify-between items-center px-10 my-1'>
													<Typography className='mr-6' variant='h6' color='ochre'>IVA</Typography>
													<Typography className='mr-6' variant='h6' color='ochre'>+ 16%</Typography>
													<Typography variant='h6'><b>${parseFloat(handleIVA(base.totales.subtotal1))}</b></Typography>
												</div>
											}
											{(base.opciones.tipoFactura == "isr") &&
												<div className='flex justify-between items-center px-10 my-1'>
													<Typography className='mr-6' variant='h6' color='ochre'>ISR</Typography>
													<Typography className='mr-6' variant='h6' color='ochre'>- 1.5%</Typography>
													<Typography variant='h6'><b>${parseFloat(handleISR(base.totales.subtotal1))}</b></Typography>
												</div>
											}
											<div className='flex justify-between items-center px-10 my-1'>
												<Typography className='mr-6' variant='h6' color='ochre'>TOTAL</Typography>
												<Typography variant='h6'><b>${base.totales.total}</b></Typography>
											</div>
											<div className='flex justify-center items-center px-10 my-3'>
												<ModalPDF
													base={base}
													tipo="1"
												>
													<Button startIcon={<DescriptionIcon />} variant='contained' color='ochre'>PDF Cliente</Button>
												</ModalPDF>
											</div>
										</CardContent>
									</Card>
								</Grid>
								<Grid size={{ xs: 4, sm: 10, md: 6 }}>
									<Card className='my-5 cardpkm'>
										<CardContent>
											{/* <div>
												<Checkbox
													{...label}
													defaultChecked
													sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
													id='distribuidorview'
													name='distribuidorview'
													checked={viewType.distribuidor}
													onChange={(e) => handleView(e)}
												/>
												<label >Ver modo Dis</label>
											</div> */}
											<Typography className='mr-6 text-center' variant='h6' color='ochre'>Distribuidor</Typography>
											<div className='flex justify-between items-center px-10 my-1'>
												<Typography className='mr-6' variant='h6' color='ochre'>SubTotal</Typography>
												<Typography variant='h6'><b>${base.totalesDistribuidor.subtotal1}</b></Typography>
											</div>
											{(base.opciones.tipoFactura == "iva" || base.opciones.tipoFactura == "isr") &&
												<div className='flex justify-between items-center px-10 my-1'>
													<Typography className='mr-6' variant='h6' color='ochre'>IVA</Typography>
													<Typography className='mr-6' variant='h6' color='ochre'>+ 16%</Typography>
													<Typography variant='h6'><b>${parseFloat(handleIVA(base.totalesDistribuidor.subtotal1))}</b></Typography>
												</div>
											}
											{(base.opciones.tipoFactura == "isr") &&
												<div className='flex justify-between items-center px-10 my-1'>
													<Typography className='mr-6' variant='h6' color='ochre'>ISR</Typography>
													<Typography className='mr-6' variant='h6' color='ochre'>- 1.5%</Typography>
													<Typography variant='h6'><b>${parseFloat(handleISR(base.totalesDistribuidor.subtotal1))}</b></Typography>
												</div>
											}
											<div className='flex justify-between items-center px-10 my-1'>
												<Typography className='mr-6' variant='h6' color='ochre'>TOTAL</Typography>
												<Typography variant='h6'><b>${base.totalesDistribuidor.total}</b></Typography>
											</div>
											<div className='flex justify-center items-center px-10 my-3'>
												<ModalPDF
													base={base}
													tipo="2"
												>
													<Button className='ml-5' startIcon={<DescriptionIcon />} variant='contained' color='blueRA'>PDF Distribuidor</Button>
												</ModalPDF>
											</div>
										</CardContent>
									</Card>
								</Grid>
							</Grid>
						</Grid>
						{/* +++++++++++++++++++++++++++++++++++++++++++++++ */}
						{/* <Grid size={{ xs: 4, sm: 10, md: 10 }}>
							<Card className='my-5 cardpkm'>
								<CardContent>
									<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 4, sm: 10, md: 12 }}>
										<Grid size={{ xs: 4, sm: 5, md: 12 }} className="flex items-center">
											<Typography color='ochre' className="ml-4 font-bold" component="h2">Totales</Typography>
										</Grid>
										<Grid size={{ xs: 4, sm: 10, md: 12 }}>
											<hr className='mb-4' />
										</Grid>

										<Grid size={{ xs: 4, sm: 10, md: 6 }}>
											<Typography className='mr-6 text-center' variant='h6' color='ochre'>Cliente</Typography>
											<div className='flex justify-between items-center px-10 my-1'>
												<Typography className='mr-6' variant='h6' color='ochre'>SubTotal</Typography>
												<Typography variant='h6'><b>${base.totales.subtotal1}</b></Typography>
											</div>
											{(base.opciones.tipoFactura == "iva" || base.opciones.tipoFactura == "isr") &&
												<div className='flex justify-between items-center px-10 my-1'>
													<Typography className='mr-6' variant='h6' color='ochre'>IVA</Typography>
													<Typography className='mr-6' variant='h6' color='ochre'>+ 16%</Typography>
													<Typography variant='h6'><b>${parseFloat(handleIVA(base.totales.subtotal1))}</b></Typography>
												</div>
											}
											{(base.opciones.tipoFactura == "isr") &&
												<div className='flex justify-between items-center px-10 my-1'>
													<Typography className='mr-6' variant='h6' color='ochre'>ISR</Typography>
													<Typography className='mr-6' variant='h6' color='ochre'>- 1.5%</Typography>
													<Typography variant='h6'><b>${parseFloat(handleISR(base.totales.subtotal1))}</b></Typography>
												</div>
											}
											<div className='flex justify-between items-center px-10 my-1'>
												<Typography className='mr-6' variant='h6' color='ochre'>TOTAL</Typography>
												<Typography variant='h6'><b>${base.totales.total}</b></Typography>
											</div>
											<div className='flex justify-center items-center px-10 my-3'>
												<ModalPDF
													base={base}
													tipo="1"
												>
													<Button startIcon={<DescriptionIcon />} variant='contained' color='ochre'>PDF Cliente</Button>
												</ModalPDF>
											</div>
										</Grid>
										<Grid size={{ xs: 4, sm: 10, md: 6 }}>
											<Typography className='mr-6 text-center' variant='h6' color='ochre'>Distribuidor</Typography>
											<div className='flex justify-between items-center px-10 my-1'>
												<Typography className='mr-6' variant='h6' color='ochre'>SubTotal</Typography>
												<Typography variant='h6'><b>${base.totalesDistribuidor.subtotal1}</b></Typography>
											</div>
											{(base.opciones.tipoFactura == "iva" || base.opciones.tipoFactura == "isr") &&
												<div className='flex justify-between items-center px-10 my-1'>
													<Typography className='mr-6' variant='h6' color='ochre'>IVA</Typography>
													<Typography className='mr-6' variant='h6' color='ochre'>+ 16%</Typography>
													<Typography variant='h6'><b>${parseFloat(handleIVA(base.totalesDistribuidor.subtotal1))}</b></Typography>
												</div>
											}
											{(base.opciones.tipoFactura == "isr") &&
												<div className='flex justify-between items-center px-10 my-1'>
													<Typography className='mr-6' variant='h6' color='ochre'>ISR</Typography>
													<Typography className='mr-6' variant='h6' color='ochre'>- 1.5%</Typography>
													<Typography variant='h6'><b>${parseFloat(handleISR(base.totalesDistribuidor.subtotal1))}</b></Typography>
												</div>
											}
											<div className='flex justify-between items-center px-10 my-1'>
												<Typography className='mr-6' variant='h6' color='ochre'>TOTAL</Typography>
												<Typography variant='h6'><b>${base.totalesDistribuidor.total}</b></Typography>
											</div>
											<div className='flex justify-center items-center px-10 my-3'>
												<ModalPDF
													base={base}
													tipo="2"
												>
													<Button className='ml-5' startIcon={<DescriptionIcon />} variant='contained' color='ochre'>PDF Distribuidor</Button>
												</ModalPDF>
											</div>
										</Grid>
										<Grid size={{ xs: 4, sm: 10, md: 6 }}>
											<div className='flex justify-center items-center px-10 my-3'>
												<ModalPDF
													base={base}
													tipo="3"
												>
													<Button className='ml-5' startIcon={<DescriptionIcon />} variant='contained' color='ochre'>PDF Medidas</Button>
												</ModalPDF>
											</div>
										</Grid>

									</Grid>
								</CardContent>
							</Card>
						</Grid> */}

					</Grid>

				</Container>

				<div className='footerMenu'>
					<Box sx={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
						<Container>
							<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 4, sm: 10, md: 12 }}>
								<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex justify-start">
									<Typography style={{display: "flex", alignItems: "center"}}>Ver Modo:</Typography>
									<div>
										<Checkbox
											{...label}
											defaultChecked
											sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
											id='clienteview'
											name='clienteview'
											checked={viewType.cliente}
											onChange={(e) => handleView(e)}
										/>
										<label >Cliente</label>
									</div>
									<div>
										<Checkbox
											{...label}
											defaultChecked
											sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
											id='distribuidorview'
											name='distribuidorview'
											checked={viewType.distribuidor}
											onChange={(e) => handleView(e)}
										/>
										<label >Distribuidor</label>
									</div>
									{/* <ModalPDF
										base={base}
										tipo="1"
									>
										<Button startIcon={<DescriptionIcon />} variant='contained' color='ochre'>PDF Cliente</Button>
									</ModalPDF>
									<ModalPDF
										base={base}
										tipo="2"
									>
										<Button className='ml-5' startIcon={<DescriptionIcon />} variant='contained' color='ochre'>PDF Distribuidor</Button>
									</ModalPDF> */}
								</Grid>
								<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex justify-end">
									<AddPersiana
										handleArticle={handleArticle}
										textbtn='Persiana'
										icon={<LibraryAddIcon />}
										tieneStringVacio={tieneStringVacio}
										toast={toast}
									/>

									<AddArticulo
										tieneStringVacio={tieneStringVacio}
										handleArticle={handleArticle}
										toast={toast}
									/>
									<AddSeccion
										tieneStringVacio={tieneStringVacio}
										handleArticle={handleArticle}
										toast={toast}
									/>
								</Grid>
							</Grid>
						</Container>

					</Box>
				</div>
			</ThemeProvider>
		</div>
	);
}

export default App;

